(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/da", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/da"] = factory();
	else
		root["i18n/da"] = factory();
})(window, function() {
return 